module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form"
  }, [(_vm.$p('settings/status/gauges')) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Status"
    }
  }, [_c('el-row', {
    attrs: {
      "justify": "space-between",
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/SDD')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.hdd_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.hdd_total) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.hdd_free) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.hdd_used) + " GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/memory')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.mem_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.mem_total) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.mem_free) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.mem_used) + " GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/camera')))])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.cam_sd_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.cam_sd_size) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.cam_sd_free) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(_vm.getSystemStatus.cam_sd_used) + " GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card-unique"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/n140')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.n140_sd_percent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/total')) + ": ")]), _vm._v(" " + _vm._s(_vm.$l('settings/status/gbOrMore')))]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/free')) + ": ")]), _vm._v(" " + _vm._s(Math.round((100 - _vm.getSystemStatus.n140_sd_percent) * 10) / 10) + "% " + _vm._s(_vm.$l('settings/status/of')) + " 2GB")]), _vm._v(" "), _c('div', {
    staticClass: "statusCharts"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/used')) + ": ")]), _vm._v(" " + _vm._s(Math.round((_vm.getSystemStatus.n140_sd_percent) * 10) / 10) + "% " + _vm._s(_vm.$l('settings/status/of')) + " 2GB")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 8,
      "md": 12,
      "sm": 8,
      "xs": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card-unique"
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(" " + _vm._s(_vm.$l('settings/status/cpu')) + " ")])])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.getSystemStatus.cpu_percent
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 8
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/firmware')))])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/status/Version') + ' :'
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getFirmware.version),
      callback: function($$v) {
        _vm.$set(_vm.getFirmware, "version", $$v)
      },
      expression: "getFirmware.version"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/status/Release') + ' :'
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getFirmware.release),
      callback: function($$v) {
        _vm.$set(_vm.getFirmware, "release", $$v)
      },
      expression: "getFirmware.release"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/status/PCFree') + ' :'
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsSystem.pchddlimit),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsSystem, "pchddlimit", $$v)
      },
      expression: "getSettingsSystem.pchddlimit"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$p('settings/status/logs')) ? _c('el-col', {
    attrs: {
      "lg": 16
    }
  }, [_c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.logs == '1'),
      expression: "getSettingsAddons.logs == '1'"
    }]
  }, [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/logs')))])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 19
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.selectedLog),
      callback: function($$v) {
        _vm.selectedLog = $$v
      },
      expression: "selectedLog"
    }
  }, _vm._l((_vm.logTypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "lg": 5
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.selectedLog
    },
    on: {
      "click": _vm.downloadClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/status/download')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.logsLoading),
      expression: "logsLoading"
    }],
    staticClass: "logsCard",
    attrs: {
      "gutter": 25
    }
  }, _vm._l((_vm.logs), function(item, i) {
    return _c('div', {
      key: i
    }, [_vm._v(_vm._s(item))])
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$p('settings/status/users')) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('div', {
    staticClass: "users-title"
  }, [_vm._v(_vm._s(_vm.$l('settings/status/users')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [(_vm.$p('settings/status/userAdmin')) ? _c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/adminUsr')))])])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$l('settings/status/username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsUsers.userAdmin),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "userAdmin", $$v)
      },
      expression: "getSettingsUsers.userAdmin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword.admin ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsUsers.pwdAdmin),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "pwdAdmin", $$v)
      },
      expression: "getSettingsUsers.pwdAdmin"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword.admin = !_vm.showPassword.admin
      }
    },
    slot: "append"
  }, [_c('icon', {
    staticClass: "show-password-icon",
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [(_vm.$p('settings/status/userOper')) ? _c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/noiseUsr')))])])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$l('settings/status/username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsUsers.userNoise),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "userNoise", $$v)
      },
      expression: "getSettingsUsers.userNoise"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword.user ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsUsers.pwdNoise),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "pwdNoise", $$v)
      },
      expression: "getSettingsUsers.pwdNoise"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword.user = !_vm.showPassword.user
      }
    },
    slot: "append"
  }, [_c('icon', {
    staticClass: "show-password-icon",
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [(_vm.$p('settings/status/userGuest')) ? _c('el-card', [_c('div', {
    staticClass: "headers",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$l('settings/status/guestUsr')))])])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$l('settings/status/username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsUsers.userGuest),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "userGuest", $$v)
      },
      expression: "getSettingsUsers.userGuest"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword.guest ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsUsers.pwdGuest),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsUsers, "pwdGuest", $$v)
      },
      expression: "getSettingsUsers.pwdGuest"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword.guest = !_vm.showPassword.guest
      }
    },
    slot: "append"
  }, [_c('icon', {
    staticClass: "show-password-icon",
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.rebootLoading
    },
    on: {
      "click": function($event) {
        return _vm.rebootSystemMessage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/status/Reboot')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149b26e4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Status.vue
// module id = 443
// module chunks = 1